import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Audience } from '../../interfaces/audience.model';
import { Storage } from '@ionic/storage';
import { BehaviorSubject } from "rxjs/BehaviorSubject";

@Injectable()
export class AudienceProvider {

  audiences: Audience[];
  selectedAudience: Audience;
  audienceSubject = new BehaviorSubject<Audience>(null);
  currentAudience = this.audienceSubject.asObservable();

  constructor(public http: HttpClient, public storage: Storage) {}

  getAudiences() {
    return this.storage.get("audiences").then((data:Audience[]) => {
      this.audiences = data;
    });
  }

  getAllAudiences(){
    return this.audiences;
  }

  setSelectedAudience(audience: Audience): Promise<any>{
    this.selectedAudience = audience;
    return this.storage.set("selectedAudience", this.selectedAudience).then(() => this.audienceSubject.next(this.selectedAudience));
  }

  getSelectedAudience() {
    return this.storage.get("selectedAudience");
  }
}



// WEBPACK FOOTER //
// ./src/providers/audience/audience.ts